import { useEffect, useState } from 'react';
import {
  // $bankInformationStore,
  $countryStore,
} from '@lib/store';
import type { AccountResponse } from '@shared/api/rest/accounts';
import { TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { OtherAccountIndividualTab } from './otherAccountIndividualTab';
import { OtherAccountBusinessTab } from './otherAccountBusinessTab';
import { $countryProvincesStore } from '@lib/store/countryProvincesStore';
import { $transferCurrenciesStore } from '@lib/store/transferCurrencies';

const allTabs = Object.entries(TransferRecipientTypeEnum).map((x) => ({ label: x[0], value: x[1] }));

interface PropsType {
  account: AccountResponse | null;
}

export const OtherAccountTab = (props: PropsType) => {
  const [currentTab, setCurrentTab] = useState<TransferRecipientTypeEnum>(TransferRecipientTypeEnum.Individual);

  useEffect(() => {
    $countryStore.events.update();
    $countryProvincesStore.events.update();
    $transferCurrenciesStore.events.update();
    // $bankInformationStore.events.getBankInformation();
  }, []);

  const currentTabView =
    currentTab == TransferRecipientTypeEnum.Individual ? (
      <OtherAccountIndividualTab allTabs={allTabs} onChangeTab={setCurrentTab} currentTab={currentTab} account={props.account} />
    ) : (
      <OtherAccountBusinessTab allTabs={allTabs} onChangeTab={setCurrentTab} currentTab={currentTab} account={props.account} />
    );

  return <>{currentTabView}</>;
};
